import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function GuaranteeSection() {
  return <section className="bg-white px-5 py-14 md:py-24" data-id="element-97" data-mp="4vs1604r2hrx">
      <Reveal className="mx-auto max-w-xl text-center" data-id="element-98" data-mp="9umggs3ido7a">
        <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-tr-green/10" data-id="element-99" data-mp="9t1nv80r8fc2">
          <ShieldCheckIcon className="h-6 w-6 text-tr-green" strokeWidth={1.75} aria-hidden="true" data-id="element-100" data-mp="ercvrd7hofrn" />
        </span>
        <h2 className="mt-5 text-[1.6rem] font-bold tracking-tight text-tr-navy md:text-3xl" data-id="element-101" data-mp="nt2oqnh0rmrj">
          Get Your Money Back or Keep It.
        </h2>
        <p className="mt-4 text-[15px] leading-relaxed text-tr-grey" data-id="element-102" data-mp="sn6wva20u0u7">
          The Tennis Ready risk is ours for 30 days. If it does not save you
          hours of prep, email us for a full refund — and you can keep every
          volume.
        </p>
      </Reveal>
    </section>;
}